import { useState } from 'react'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import { SocialShareDrawer } from 'components/SocialShareDrawer'
import { assetUrl } from 'utils/url'

import type { IInfoTerkiniDocument } from 'types/info-terkini'

interface DocumentListItemProps {
  document: IInfoTerkiniDocument
}

const needToClamp = (content: string, limit: number) => content.length > limit

const ellipsisText = (content: string, limit: number) => {
  return needToClamp(content, limit)
    ? `${content.substring(0, limit)} ...`
    : content
}

const DocumentListItem = ({ document }: DocumentListItemProps) => {
  const onDownloadClick = () => {
    window.open(document.fileUrl, '_blank')
  }
  const [shareDrawerOpen, setShareDrawerOpen] = useState(false)
  const onShareClick = () => {
    setShareDrawerOpen(true)
  }

  const shareText = `Info terkini dari Kemendikbudristek! Baca ${document.name} di sini`

  const isImageFile = (fileName: string): boolean =>
    /\.(png|jpe?g)$/.test(fileName)

  return (
    <div
      className="flex items-center py-4 border-b border-subdued"
      data-testid="document-list-item"
    >
      {isImageFile(document.fileUrl) ? (
        <img
          src={assetUrl('/icon/file-img-new.svg')}
          width={24}
          height={24}
          alt="image icon"
        />
      ) : (
        <img
          src={assetUrl('/icon/file-pdf.svg')}
          width={24}
          height={24}
          alt="pdf icon"
        />
      )}

      <div className="w-full ml-3">
        <Text variant="body">
          <a href={document.fileUrl} target="_blank" download rel="noreferrer">
            {ellipsisText(document.name, 40)}
          </a>
        </Text>
        <Text variant="helper" color="subdued">
          {document.fileSize}
        </Text>
      </div>

      <div className="flex items-center ml-4">
        <button onClick={onShareClick} data-testid="share">
          <Icon>share</Icon>
        </button>
        <button
          className="ml-4"
          onClick={onDownloadClick}
          data-testid="download"
        >
          <Icon>download</Icon>
        </button>
      </div>

      <SocialShareDrawer
        shareText={shareText}
        isOpen={shareDrawerOpen}
        onClose={() => setShareDrawerOpen(false)}
        shareUrl={document.fileUrl}
        title="Bagikan Info"
      />
    </div>
  )
}

export default DocumentListItem
